import React from 'react';
import PropTypes from 'prop-types';
import { getOverlappingDaysInIntervals } from 'date-fns/esm';


/* Simple metric allows you to provide a text label and numeric value.
   Default color is grey 
*/

export const SimpleMetric  = (props) => {

    // Define default styles

    let metricStyle = {
        box:  {
            backgroundColor: '#a5d6a7',
            border: '1px solid $greyshade2',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '5rem',
            width: '8.5rem',
            margin: '.2rem'
        },
    
        label: {
            color: 'black',
            fontSize: '1.1rem',
            fontStyle: 'inherit',
            fontWeight: '900'
        },
    
        metric: {
            color: 'white',
            fontStyle: 'inherit',
            fontSize: '1.4rem',
            fontWeight: '900'
        }
    }
    
    // /* construct class name */
    // if (props.color) {
    //     metricStyle = metricStyle + '-' + props.color;
    // }

    /* set prop values for child nodes */
    let label    = props.label;
    let metric   = props.metric;

    /* set prop values for style properties */
    metricStyle.box.backgroundColor =  props.bgColor;
    metricStyle.label.color  =  props.labelColor;
    metricStyle.metric.color =  props.metricColor;

    // if (props.altstyle) { 
    //     buttonstyle = "simple-button-alt";
    // } 

    return  (
      <div style={metricStyle.box}>
         <div style={metricStyle.label}>{label}</div>
         <div style={metricStyle.metric}>{metric}</div>
      </div>
    )
}

SimpleMetric.propTypes = {
    label:          PropTypes.string.isRequired,
    metric:         PropTypes.string.isRequired,
    bgColor:        PropTypes.string,
    labelColor:     PropTypes.string,
    metricColor:    PropTypes.string
}

SimpleMetric.defaultProps = {
    label: 'Metric A',
    metric: '97',
    bgColor: 'grey',
    labelColor: 'black',
    metricColor: 'white'
}





// export const SimpleMetric  = (props) => {

//     let metricStyle = "simple-metric"
    
//     /* construct class name */
//     if (props.color) {
//         metricStyle = metricStyle + '-' + props.color;
//     }

//     /* get prop values */
//     let label    = props.label;
//     let metric   = props.metric;
//     let bgColor  = props.bgColor;
//     let bgColor  = props.bgColor;



//     // if (props.altstyle) { 
//     //     buttonstyle = "simple-button-alt";
//     // } 

//     return  (
//       <div className="simple-metric">
//          <div className="simple-metric-label-font">{label}</div>
//          <div className="simple-metric-metric-font">{metric}</div>
//       </div>
//     )
// }

// SimpleMetric.propTypes = {
//     label:          PropTypes.string.isRequired,
//     metric:         PropTypes.string.isRequired,
//     bgColor:        PropTypes.string,
//     labelColor:     PropTypes.string,
//     metricColor:    PropTypes.string
// }

// SimpleMetric.defaultProps = {
//     label: 'Metric A',
//     metric: '97',
//     bgColor: 'grey',
//     labelColor: 'black',
//     metricColor: 'white',
// }


// WEBPACK FOOTER //
// ./src/components/metrics/SimpleMetric.js